import React from 'react';
import { useWindowSize } from 'usehooks-ts';
import { ReadMore } from '../ReadMore';
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import {
  UncheckedCheckbox,
  CheckedCheckbox,
  CheckedRadio,
  UncheckedRadio,
} from 'components';

function QuestionSubtitle({ content }) {
  const screenSize = useWindowSize();

  if (!content) {
    return <></>;
  }

  if (content >= 150 && screenSize.width < 600) {
    return <ReadMore limit={150}>{content}</ReadMore>;
  }

  return <h2>{content}</h2>;
}

const RADIO_VALUES = ['None of the above'];

export function QuestionContents({ question, selected, setSelected }) {
  const isSingleSelection = !question.multi;

  function handleSelection(e, option) {
    if (!e.target.checked) {
      setSelected(selected.filter((item) => item !== option.value));
      return;
    }

    if (
      RADIO_VALUES.includes(option.value) ||
      (selected.length == 1 && RADIO_VALUES.includes(selected[0]))
    ) {
      setSelected([option.value]);
      return;
    }

    if (isSingleSelection) {
      setSelected([option.value]);
      return;
    }

    setSelected([...selected, option.value]);
  }

  return (
    <>
      <div className="question-subtitle">
        <QuestionSubtitle content={question.subtitle} />
      </div>

      <FormGroup
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1em',
          alignContent: 'center',
        }}>
        {question.options?.map((option, index) => {
          const isRadio =
            isSingleSelection || RADIO_VALUES.includes(option.value);

          const Icon = isRadio ? UncheckedRadio : UncheckedCheckbox;
          const CheckedIcon = isRadio ? CheckedRadio : CheckedCheckbox;

          return (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={option.value}
                  icon={<Icon />}
                  checkedIcon={<CheckedIcon />}
                  checked={selected.includes(option.value)}
                  onChange={(e) => handleSelection(e, option)}
                  sx={{ padding: '0 0.5em 0.5em 0' }}
                />
              }
              label={option.value}
            />
          );
        })}
      </FormGroup>
    </>
  );
}